import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import Layout from './components/Layout'
import LoginPage from './pages/auth/LoginPage'
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage'
import Dashboard from './pages/Dashboard'
import CampaignListPage from './pages/campaigns/CampaignListPage'
import CampaignDetailPage from './pages/campaigns/CampaignDetailPage'
import CampaignCreatePage from './pages/campaigns/CampaignCreatePage'
import CampaignEditPage from './pages/campaigns/CampaignEditPage'
import CreativeListPage from './pages/creatives/CreativeListPage'
import StoreListPage from './pages/stores/StoreListPage'
import StoreDetailPage from './pages/stores/StoreDetailPage'
import StoreCreatePage from './pages/stores/StoreCreatePage'
import StoreEditPage from './pages/stores/StoreEditPage'
import StoreGroupListPage from './pages/store-groups/StoreGroupListPage'
import AdSlotListPage from './pages/ad-slots/AdSlotListPage'
import ReportPage from './pages/reports/ReportPage'
import SettingsPage from './pages/settings/SettingsPage'
import UserListPage from './pages/users/UserListPage'

// Protected Route wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore()
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  
  return <>{children}</>
}

// Public Route wrapper (redirect if already authenticated)
function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore()
  
  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }
  
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPasswordPage />
          </PublicRoute>
        }
      />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        
        {/* Campaigns */}
        <Route path="campaigns" element={<CampaignListPage />} />
        <Route path="campaigns/new" element={<CampaignCreatePage />} />
        <Route path="campaigns/:id" element={<CampaignDetailPage />} />
        <Route path="campaigns/:id/edit" element={<CampaignEditPage />} />
        
        {/* Creatives */}
        <Route path="creatives" element={<CreativeListPage />} />
        
        {/* Stores */}
        <Route path="stores" element={<StoreListPage />} />
        <Route path="stores/new" element={<StoreCreatePage />} />
        <Route path="stores/:id" element={<StoreDetailPage />} />
        <Route path="stores/:id/edit" element={<StoreEditPage />} />
        
        {/* Store Groups */}
        <Route path="store-groups" element={<StoreGroupListPage />} />
        
        {/* Ad Slots */}
        <Route path="ad-slots" element={<AdSlotListPage />} />
        
        {/* Reports */}
        <Route path="reports" element={<ReportPage />} />
        
        {/* Settings */}
        <Route path="settings" element={<SettingsPage />} />
        
        {/* Users */}
        <Route path="users" element={<UserListPage />} />
        
        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
